import service from '@api/config'

// 同意完工
export const agreeFinish = (data) => {
  return service.request({
    url: `/project/agreeFinish`,
    method: 'post',
    data: data
  })
}
//驳回完工申请
export const refuseFinish = (data) => {
  return service.request({
    url: `/project/refuseFinish`,
    method: 'post',
    data: data
  })
}

//根据完工申请id获取完工信息
export const getFinishInfo = (data) => {
  return service.request({
    url: `/message/getFinishInfo`,
    method: 'post',
    data: data
  })
}

//项目待评价完工信息
export const projectFinishInfo = (data) => {
  return service.request({
    url: `/message/projectFinishInfo`,
    method: 'post',
    data: data
  })
}

//投标单位评价
export const unitAssess = (data) => {
  return service.request({
    url: `/message/unitAssess`,
    method: 'post',
    data: data
  })
}

// 队伍已评价信息
export const companyAssessInfo = (data) => {
  return service.request({
    url: `/message/companyAssessInfo`,
    method: 'post',
    data: data
  })
}
// 根据项目id获取候选人公告
export const getPublicityInfo = (data) => {
  return service.request({
    url: `/message/getPublicityInfo`,
    method: 'post',
    data: data
  })
}

// 根据待确认id获取接标信息
export const getAccetpInfo = (data) => {
  return service.request({
    url: `/message/getAccetpInfo`,
    method: 'post',
    data: data
  })
}

// 项目完工队伍人员待评价信息
export const workerFinishInfo = (data) => {
  return service.request({
    url: `/message/workerFinishInfo`,
    method: 'post',
    data: data
  })
}

// 项目人员评价
export const workerAssess = (data) => {
  return service.request({
    url: `/message/workerAssess`,
    method: 'post',
    data: data
  })
}

// 项目参与人员已评价信息
export const workerAssessInfo = (data) => {
  return service.request({
    url: `/message/workerAssessInfo`,
    method: 'post',
    data: data
  })
}

// 参与人员查看评价
export const getMyAssess = (data) => {
  return service.request({
    url: `/message/getMyAssess`,
    method: 'post',
    data: data
  })
}
